import * as Yup from 'yup';
import { ALL_WAREHOUSE_PERMISSION } from '../global/variables/userGroups';

const errorValidate = (err) => {
  const validationErrors = {};
  if (err instanceof Yup.ValidationError) {
    err.inner.forEach((error) => {
      validationErrors[error.path] = error.message;
    });
    document.getElementById(Object.keys(validationErrors)[0])?.focus();
    return {
      error: validationErrors,
    };
  }
};

export const loginForm = async (data) => {
  try {
    const schema = Yup.object().shape({
      email: Yup.string()
        .required('Digite um e-mail válido')
        .email('E-mail inválido'),
      password: Yup.string()
        .required('Senha obrigatório.')
        .min(8, 'No mínimo 8 caracteres.'),
    });

    await schema.validate(data, {
      abortEarly: false,
    });

    return {
      payload: data,
    };
  } catch (err) {
    return errorValidate(err);
  }
};

export const validateEmailConfirmationForm = async (data) =>{
  try{
    const schema = Yup.object().shape({
      tokenOtp: Yup.string()
      .required("Digite ocódigo de verificação")
      .length(6, "O código deve possuir 6 digitos.")
    })

    await schema.validate(data, {
      abortEarly: false
    })

    return{
      payload: data
    }
  }catch (err){
    return errorValidate(err)
  }
}

export const userForm = async (data, id, userGroup = '') => {
  try {
    const validate = {
      name: Yup.string().required('Nome obrigatório'),
      email: Yup.string()
        .required('Digite um e-mail válido')
        .email('E-mail inválido'),
      emailConfirmed: Yup.string()
        .oneOf([data.email], 'E-mail não confere')
        .required('E-mail não confere')
        .email('E-mail inválido'),
      userGroup: Yup.string().required('Grupo obrigatório'),
      userRole: Yup.string().required('Nível obrigatório'),
      status: Yup.string(),
      userLinks: !ALL_WAREHOUSE_PERMISSION.includes(userGroup)
        ? Yup.array().test(
          "Quantidade depósitos",
          "Este usuário deve selecionar pelo menos um depósito",
          array => array.length > 0
        )
        : Yup.array(),
      reason: id
        ? Yup.string()
            .min(5, 'Tem poucos caracteres')
            .max(100, 'Ultrapassou o limite caracteres')
            .required('Motivo obrigatório')
        : Yup.string(),
    };
    const schema = Yup.object().shape(validate);

    await schema.validate(data, {
      abortEarly: false,
    });

    return {
      payload: data,
    };
  } catch (err) {
    return errorValidate(err);
  }
};

export const passwordForm = async (data) => {
  try {
    const schema = Yup.object().shape({
      oldPassword: Yup.string().required('Campo obrigatório'),
      newPassword: Yup.string()
        .min(8, 'No mínimo 8 caracteres')
        .notOneOf(
          [data.oldPassword],
          'A senha não pode ser a mesma do que a atual.',
        )
        .required('Senha obrigatória')
        .test(
          'Senha valida',
          'A senha deve conter pelo menos uma letra maiúscula, uma letra minúscula, um número e um símbolo',
          (value, context) => {
            const hasUpperCase = /[A-Z]/.test(value);
            const hasLowerCase = /[a-z]/.test(value);
            const hasNumber = /[0-9]/.test(value);
            const hasSymbole = /[!@#%&]/.test(value);

            return hasUpperCase && hasLowerCase && hasNumber && hasSymbole
          }
        ),
      passwordConfirmed: Yup.string()
        .min(8, 'No mínimo 8 caracteres')
        .notOneOf(
          [data.oldPassword],
          'A senha não pode ser a mesma do que a atual.',
        )
        .oneOf([data.newPassword], 'Senha não confere')
        .required('Confirmação de senha obrigatória'),
    });

    await schema.validate(data, {
      abortEarly: false,
    });

    return {
      payload: data,
    };
  } catch (err) {
    return errorValidate(err);
  }
};

export const motiveForm = async (data) => {
  try {
    const schema = Yup.object().shape({
      reason: Yup.string()
        .min(5, 'Tem poucos caracteres')
        .max(100, 'No ultrapassou o limite caracteres')
        .required('Motivo obrigatório'),
    });

    await schema.validate(data, {
      abortEarly: false,
    });

    return {
      payload: data,
    };
  } catch (err) {
    return errorValidate(err);
  }
};

export const reasonForm = async (data) => {
  try {
    const schema = Yup.object().shape({
      reason: Yup.string()
        .min(5, 'Tem poucos caracteres')
        .max(100, 'No ultrapassou o limite caracteres')
        .required('Motivo obrigatório'),
      deliveredDate: data.confirmed
        ? Yup.string().required('Data de entrega obrigatório')
        : Yup.string(),
    });

    await schema.validate(data, {
      abortEarly: false,
    });

    return {
      payload: data,
    };
  } catch (err) {
    return errorValidate(err);
  }
};

export const warehouseContactForm = async (data) => {
  try {
    const schema = Yup.object().shape({
      contactName: Yup.string().required('Nome do Responsável obrigatório.'),
      phone: Yup.string()
        .required('Telefone obrigatório.')
        .min(15, 'Telefone inválido.'),
      email: Yup.string()
        .email('E-mail inválido')
        .required('Email obrigatório.'),
    });

    await schema.validate(data, {
      abortEarly: false,
    });

    return {
      payload: data,
    };
  } catch (err) {
    return errorValidate(err);
  }
};

export const warehouseForm = async (data) => {
  try {
    const schema = Yup.object().shape({
      codeSap: Yup.string().required('Código do depósito obrigatório.'),
      name: Yup.string().required('Nome do depósito obrigatório.'),
      address: Yup.string().required('Endereço obrigatório.'),
      number: Yup.string().required('Número obrigatório.'),
      city: Yup.string().required('Cidade obrigatório.'),
      latitude: Yup.string()
        .required('Latitude obrigatório.')
        .max(10, 'Latitude tem que ser no máximo 10 caracteres'),
      longitude: Yup.string()
        .required('Longitude obrigatório.')
        .max(10, 'Longitude tem que ser no máximo 10 caracteres'),
    });

    await schema.validate(data, {
      abortEarly: false,
    });

    return {
      payload: data,
    };
  } catch (err) {
    return errorValidate(err);
  }
};
